import LoginComponent from '../login-component';
import LoginCheckbox from '../ui-elements/login-checkbox';
import FormActions from '../../logic/form-actions';

import {localize} from '../../infrastructure/localization';

import './keep-logged-in-checkbox.scss';

export default class KeepLoggedInCheckbox extends LoginComponent {

    constructor(props) {
        super(props);
    }

    render () {
        return (
            <div className="keep-logged-in-placeholder">
                <LoginCheckbox
                    componentId={this.state.componentId}
                    checked={this.state.loginModel.keepLoggedIn}
                    onChange={(e) => FormActions.changeKeepLoggedIn(this.state.componentId)}
                    label={localize('form-components.keep-logged-in')} />
            </div>
        )
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/form-components/keep-logged-in-checkbox.jsx
 **/